import { isString } from 'mathjs';
import Action from '../../classes/Action';
import MaterialAsset from '../../classes/MaterialAsset';
import ProjectSaver from '../../classes/ProjectSaver';
import { SaveModificationTypes } from '../../globals';

export default class ReplaceMaterial extends Action
{
	constructor(oldAssetId: string, newAssetId: string)
	{
		const oldMaterialAsset = MaterialAsset.getMaterialAssetByGuid(oldAssetId);
		const newMaterialAsset = MaterialAsset.getMaterialAssetByGuid(newAssetId);
		const actionName = "Replaced " + oldMaterialAsset?.name + " References With " + oldMaterialAsset?.name;

		super([oldMaterialAsset, newMaterialAsset], [newMaterialAsset, oldMaterialAsset], actionName, [oldAssetId, newAssetId]);
	}

	do(oldMaterialAsset: MaterialAsset, newMaterialAsset: MaterialAsset) : void
	{		
		MaterialAsset.replaceObjectCustomMaterialReferences(oldMaterialAsset, newMaterialAsset, true);
		
		for(let i = oldMaterialAsset.assignedObjects.length - 1; i >= 0; i--)
		{
			const object = oldMaterialAsset.assignedObjects[i];
			if(!object.userData.isCachedAssetObject)
			{
				MaterialAsset.assignMaterialAssetToObject(newMaterialAsset, object, true);
				ProjectSaver.getInstance().markModifiedObject(object, SaveModificationTypes.Material);
			}
		}
	}

	verify(oldAssetId: string, newAssetId: string) : boolean
	{
		return 	oldAssetId !== newAssetId && 
				isString(oldAssetId) && isString(newAssetId) &&
				MaterialAsset.getMaterialAssetByGuid(oldAssetId) !== undefined && 
				MaterialAsset.getMaterialAssetByGuid(newAssetId) !== undefined;
	}
}
